import request from '@/utils/request'
const BASE_URL = '/ReceiptWoDts'
const BASE_URL2 = '/RpPayWoDts'
export default {
needRcvList(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  needPayList2(data) {
    return request({
      url: BASE_URL2 + '/List',
      method: 'post',
      data
    })
  }
}